import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../../contexts/LanguageContext';

/**
 * mode: 'approve' | 'reject' | 'return'
 * reject -> reason zorunlu, return -> note zorunlu, approve -> not opsiyonel.
 */
const ActionDialog = ({ visible, mode, onHide, onConfirm, loading }) => {
    const { th } = useLanguage();
    const [text, setText] = useState('');
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (visible) {
            setText('');
            setSubmitted(false);
        }
    }, [visible, mode]);

    const required = mode === 'reject' || mode === 'return';
    const label = mode === 'reject' ? th('dealerApproval.reason') : th('dealerApproval.note');
    const header = mode === 'approve' ? th('dealerApproval.approve') : mode === 'reject' ? th('dealerApproval.reject') : th('dealerApproval.return');

    const handleConfirm = () => {
        setSubmitted(true);
        if (required && !text.trim()) return;
        onConfirm(text.trim());
    };

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button label={th('common.cancel')} icon="pi pi-times" outlined onClick={onHide} />
            <Button label={header} icon="pi pi-check" onClick={handleConfirm} loading={loading} />
        </div>
    );

    return (
        <Dialog visible={visible} header={header} modal style={{ width: '480px' }} footer={footer} onHide={onHide}>
            <div className="field">
                <label className="font-bold block mb-2">
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
                <InputTextarea value={text} onChange={(e) => setText(e.target.value)} rows={4} className={submitted && required && !text.trim() ? 'p-invalid w-full' : 'w-full'} autoResize />
                {submitted && required && !text.trim() && <small className="p-error">{th('common.requiredField')}</small>}
            </div>
        </Dialog>
    );
};

export default ActionDialog;
